module.exports = __webpack_public_path__ + "img/outlet.adf6aea.svg";